import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllBlogsAction } from "../../../utils/redux/blog/blogAction";
import { Link } from "react-router-dom";
import { deleteMethod } from "../../../utils/api-service/api-service";
import { toast } from "react-toastify";

const BlogListing = () => {

    const dispatch = useDispatch();
    const { blogs, loading } = useSelector(state => state.blog);

    const handleDelete = async (id) => {

        if (
            !window.confirm(
                "Delete this blog?"
            )
        ) {
            return;
        }

        const res = await deleteMethod(
            `/blog/${id}`
        );

        if (res.success) {

            toast.success(
                "Blog deleted"
            );

            dispatch(
                fetchAllBlogsAction()
            );
        }
    };

    useEffect(() => {
        dispatch(fetchAllBlogsAction());
    }, []);

    return (
        <div className="d-flex flex-column align-items-center">

            <div className="d-flex my-4 w-100 justify-content-between">
                <h3>Blog Articles</h3>

                <Link
                    to="/create-blog"
                    className="btn btn-primary"
                >
                    + Add Blog
                </Link>
            </div>

            <div className="w-100">
                <table className="table table-sm align-middle">

                    <thead className="table-secondary">
                        <tr>
                            <th className="p-3">Title</th>
                            <th className="p-3">Author</th>
                            <th className="p-3">Status</th>
                            <th className="p-3">Actions</th>
                        </tr>
                    </thead>

                    <tbody>
                        {blogs?.length ? (
                            blogs.map(blog => (
                                <tr key={blog._id}>

                                    <td>
                                        <Link to={`/blogs/${blog._id}`}>
                                            {blog.title}
                                        </Link>
                                    </td>

                                    <td>{blog.author}</td>
                                    <td>
                                        <span
                                            className={`badge ${blog.status === "published"
                                                ? "bg-success"
                                                : "bg-warning text-dark"
                                                }`}
                                        >
                                            {blog.status}
                                        </span>
                                    </td>

                                    <td>
                                        <div className="d-flex gap-2">

                                            <Link
                                                to={`/blogs/${blog._id}`}
                                                className="btn btn-sm btn-info"
                                            >
                                                View
                                            </Link>

                                            <Link
                                                to={`/blogs/edit/${blog._id}`}
                                                className="btn btn-sm btn-primary"
                                            >
                                                Edit
                                            </Link>

                                            <button
                                                className="btn btn-sm btn-danger"
                                                onClick={() => handleDelete(blog._id)}
                                            >
                                                Remove
                                            </button>

                                        </div>
                                    </td>

                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="3" className="text-center text-muted">
                                    {loading ? "Loading..." : "No Blogs Found"}
                                </td>
                            </tr>
                        )}
                    </tbody>

                </table>
            </div>

        </div>
    );
};

export default BlogListing;